module.exports = __webpack_public_path__ + "img/icons8-plus.8dd70101.svg";